const resolveIconColor = (color) => {
  switch (color) {
    case "black":
      return "var(--figurine-icons-black)";
    case "light":
      return "var(--figurine-icons-light)";
    case "dark":
      return "var(--figurine-icons-dark)";
    case "cta":
      return "var(--figurine-body-primary600)";
    case "error":
      return "var(--figurine-feedback-error)";
    case "neutral":
      return "var(--figurine-icons-neutral)";
    case "secondary":
      return "var(--figurine-icons-secondary)";
    case "success":
      return "var(--figurine-feedback-success)";
    case "warning":
      return "var(--figurine-feedback-warning)";
    case "spot":
      return "var(--figurine-spot-light)";
    default:
      return "var(--figurine-icons-black)";
  }
};
const resolveSize = (size) => {
  switch (size) {
    case "xs":
      return "var(--ai-size-xs)";
    case "sm":
      return "var(--ai-size-sm)";
    case "md":
      return "var(--ai-size-md)";
    case "lg":
      return "var(--ai-size-lg)";
    case "xl":
      return "var(--ai-size-xl)";
    default:
      return size;
  }
};
const resolveRadius = (radius) => {
  switch (radius) {
    case "xs":
      return "var(--mantine-radius-xs)";
    case "sm":
      return "var(--mantine-radius-sm)";
    case "md":
      return "var(--mantine-radius-md)";
    case "lg":
      return "var(--mantine-radius-lg)";
    case "xl":
      return "var(--mantine-radius-xl)";
    default:
      return radius;
  }
};
const resolvePadding = (padding) => {
  switch (padding) {
    case "xs":
      return "var(--mantine-spacing-xs)";
    case "sm":
      return "var(--mantine-spacing-sm)";
    case "md":
      return "var(--mantine-spacing-md)";
    case "lg":
      return "var(--mantine-spacing-lg)";
    case "xl":
      return "var(--mantine-spacing-xl)";
    default:
      return padding;
  }
};
const Icon_helpers = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  resolveIconColor,
  resolvePadding,
  resolveRadius,
  resolveSize
}, Symbol.toStringTag, { value: "Module" }));
export {
  Icon_helpers as I,
  resolveIconColor,
  resolvePadding,
  resolveRadius,
  resolveSize
};
